import React from 'react';
import Seo from '../components/Seo';
import { Mail, Phone, MapPin, Shield, Users, FileText } from 'lucide-react';

const ImpressumPage = () => {
  return (
    <div className="min-h-screen bg-stone-50">
      <Seo 
        title="Impressum - Fliesen Jarek | Rechtliche Angaben"
        description="Impressum von Fliesen Jarek - Alle rechtlichen Angaben nach TMG. Jarek Jozwiak, Fliesenlegermeister in Cuxhaven."
        keywords="Impressum, Fliesen Jarek, TMG, rechtliche Angaben, Cuxhaven"
      />
      
      <div className="max-w-4xl mx-auto px-6 py-20">
        {/* Header */}
        <div className="text-center mb-16">
          <h1 className="text-4xl lg:text-5xl font-light text-stone-800 mb-6">
            Impressum
          </h1>
          <p className="text-lg text-stone-600 max-w-2xl mx-auto">
            Angaben gemäß § 5 TMG und verantwortlich für den Inhalt nach § 55 Abs. 2 RStV
          </p>
        </div>

        {/* Main Content */}
        <div className="space-y-12">
          {/* Diensteanbieter */}
          <div className="bg-white p-8 rounded-lg shadow-sm">
            <div className="flex items-center mb-6">
              <Users className="w-6 h-6 text-primary-600 mr-3" />
              <h2 className="text-2xl font-semibold text-stone-800">Diensteanbieter</h2>
            </div>
            <div className="grid md:grid-cols-2 gap-8">
              <div>
                <h3 className="font-semibold text-stone-800 mb-4">Inhaber</h3>
                <p className="text-stone-600 leading-relaxed">
                  <strong>Jarek Jozwiak</strong><br />
                  Fliesenlegermeister<br />
                  Einzelunternehmen
                </p>
              </div>
              <div>
                <h3 className="font-semibold text-stone-800 mb-4">Geschäftstätigkeit</h3>
                <p className="text-stone-600 leading-relaxed">
                  Fliesenlegerarbeiten<br />
                  Badsanierung<br />
                  Natursteinverlegung<br />
                  Reparaturservice
                </p>
              </div>
            </div>
          </div>

          {/* Kontaktdaten */}
          <div className="bg-white p-8 rounded-lg shadow-sm">
            <div className="flex items-center mb-6">
              <Phone className="w-6 h-6 text-primary-600 mr-3" />
              <h2 className="text-2xl font-semibold text-stone-800">Kontaktdaten</h2>
            </div>
            <div className="grid md:grid-cols-2 gap-8">
              <div className="space-y-4">
                <div className="flex items-start space-x-3">
                  <MapPin className="w-5 h-5 text-primary-600 mt-1" />
                  <div>
                    <p className="font-medium text-stone-800">Anschrift</p>
                    <p className="text-stone-600">
                      Cuxhaven<br />
                      Deutschland
                    </p>
                  </div>
                </div>
                <div className="flex items-start space-x-3">
                  <Phone className="w-5 h-5 text-primary-600 mt-1" />
                  <div>
                    <p className="font-medium text-stone-800">Telefon</p>
                    <p className="text-stone-600">0151 54610847</p>
                  </div>
                </div>
                <div className="flex items-start space-x-3">
                  <Mail className="w-5 h-5 text-primary-600 mt-1" />
                  <div>
                    <p className="font-medium text-stone-800">E-Mail</p>
                    <p className="text-stone-600">jarek.j79@web.de</p>
                  </div>
                </div>
              </div>
              <div className="space-y-4">
                <div>
                  <p className="font-medium text-stone-800 mb-2">Servicegebiet</p>
                  <p className="text-stone-600">
                    Cuxhaven und Umgebung<br />
                    Landkreis Cuxhaven<br />
                    Nach Vereinbarung deutschlandweit
                  </p>
                </div>
                <div>
                  <p className="font-medium text-stone-800 mb-2">Geschäftszeiten</p>
                  <p className="text-stone-600">
                    Montag - Freitag: 8:00 - 17:00 Uhr<br />
                    Samstag: Nach Vereinbarung<br />
                    Sonntag: Geschlossen
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Rechtliche Angaben */}
          <div className="bg-white p-8 rounded-lg shadow-sm">
            <div className="flex items-center mb-6">
              <Shield className="w-6 h-6 text-primary-600 mr-3" />
              <h2 className="text-2xl font-semibold text-stone-800">Rechtliche Angaben</h2>
            </div>
            <div className="grid md:grid-cols-2 gap-8">
              <div className="space-y-4">
                <div>
                  <p className="font-medium text-stone-800 mb-2">Handwerkskammer</p>
                  <p className="text-stone-600">
                    Handwerkskammer Braunschweig-Lüneburg-Stade<br />
                    Eingetragener Handwerksbetrieb
                  </p>
                </div>
                <div>
                  <p className="font-medium text-stone-800 mb-2">Berufsgenossenschaft</p>
                  <p className="text-stone-600">
                    BG BAU - Berufsgenossenschaft der Bauwirtschaft
                  </p>
                </div>
              </div>
              <div className="space-y-4">
                <div>
                  <p className="font-medium text-stone-800 mb-2">Berufsbezeichnung</p>
                  <p className="text-stone-600">
                    Fliesenlegermeister<br />
                    (verliehen in Deutschland)
                  </p>
                </div>
                <div>
                  <p className="font-medium text-stone-800 mb-2">Aufsichtsbehörde</p>
                  <p className="text-stone-600">
                    Gewerbeaufsichtsamt Lüneburg<br />
                    Niedersächsisches Gewerbeaufsichtsamt
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Haftungsausschluss */}
          <div className="bg-white p-8 rounded-lg shadow-sm">
            <div className="flex items-center mb-6">
              <FileText className="w-6 h-6 text-primary-600 mr-3" />
              <h2 className="text-2xl font-semibold text-stone-800">Haftungsausschluss</h2>
            </div>
            <div className="space-y-6 text-stone-600 leading-relaxed">
              <div>
                <h3 className="font-semibold text-stone-800 mb-3">Inhalt des Onlineangebotes</h3>
                <p>
                  Der Autor übernimmt keinerlei Gewähr für die Aktualität, Korrektheit, Vollständigkeit oder Qualität der bereitgestellten Informationen. Haftungsansprüche gegen den Autor, welche sich auf Schäden materieller oder ideeller Art beziehen, die durch die Nutzung oder Nichtnutzung der dargebotenen Informationen bzw. durch die Nutzung fehlerhafter und unvollständiger Informationen verursacht wurden, sind grundsätzlich ausgeschlossen.
                </p>
              </div>
              <div>
                <h3 className="font-semibold text-stone-800 mb-3">Verweise und Links</h3>
                <p>
                  Bei direkten oder indirekten Verweisen auf fremde Internetseiten ("Links"), die außerhalb des Verantwortungsbereiches des Autors liegen, würde eine Haftungsverpflichtung ausschließlich in dem Fall in Kraft treten, in dem der Autor von den Inhalten Kenntnis hat und es ihm technisch möglich und zumutbar wäre, die Nutzung im Falle rechtswidriger Inhalte zu verhindern.
                </p>
              </div>
              <div>
                <h3 className="font-semibold text-stone-800 mb-3">Urheberrecht</h3>
                <p>
                  Der Autor ist bestrebt, in allen Publikationen die Urheberrechte der verwendeten Grafiken, Tondokumente, Videosequenzen und Texte zu beachten, von ihm selbst erstellte Grafiken, Tondokumente, Videosequenzen und Texte zu nutzen oder auf lizenzfreie Grafiken, Tondokumente, Videosequenzen und Texte zurückzugreifen.
                </p>
              </div>
            </div>
          </div>

          {/* Streitbeilegung */}
          <div className="bg-white p-8 rounded-lg shadow-sm">
            <h2 className="text-2xl font-semibold text-stone-800 mb-6">Streitbeilegung</h2>
            <p className="text-stone-600 leading-relaxed">
              Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit: 
              <a href="https://ec.europa.eu/consumers/odr/" target="_blank" rel="noopener noreferrer" className="text-primary-600 hover:underline ml-1">
                https://ec.europa.eu/consumers/odr/
              </a>
              <br /><br />
              Zur Teilnahme an einem Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle sind wir nicht verpflichtet und nicht bereit.
            </p>
          </div>
        </div>

        {/* Footer Note */}
        <div className="text-center mt-16 pt-8 border-t border-stone-200">
          <p className="text-sm text-stone-500">
            Stand: {new Date().toLocaleDateString('de-DE', { 
              year: 'numeric', 
              month: 'long', 
              day: 'numeric' 
            })}
          </p>
        </div>
      </div>
    </div>
  );
};

export default ImpressumPage; 